import React from "react";
import RFProfileGroupList from "../Components/ListView/ListView";

/**
 * RFProfileGroup (Shadcn + TypeScript)
 * - Replaces legacy Kendo grid with centralized ListView-based list
 * - Uses RFProfileGroupList wrapper to connect services and row renderer
 */
const RFProfileGroup: React.FC = () => {
  return (
    <div className="w-full px-3 sm:pl-4 sm:pr-0 py-4 lg:w-[calc(50vw+18rem-16px)] lg:max-w-full">
      <RFProfileGroupList />
    </div>
  );
};

export default RFProfileGroup;
